import './App.css';
import React from "react";
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import Home from './home';
import Contact from './contact';

function App() {
  return (
    <div className="App">
      <BrowserRouter basename="/">
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace={true} />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contactus" element={<Contact />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
